import React from "react";
import { Redirect } from "react-router-dom";

// Layout Types
import { DefaultLayout } from "./layouts";

// Route Views
import Dashboard from "./views/Dashboard";
import Areas from "./views/Areas";
import Apps from "./views/Apps";
import AppDetailsView from "./views/AppDetailsView";
import AreaDetailsView from "./views/AreaDetailsView";
import Login from "./views/Login";

export default [
  {
    path: "/",
    exact: true,
    layout: DefaultLayout,
    component: () => <Redirect to="/home" />
  },
  {
    path: "/home",
    layout: DefaultLayout,
    component: Dashboard
  },
  {
    path: "/logout/:user_logout",
    layout: DefaultLayout,
    component: Login
  },
  {
    path: "/areas",
    layout: DefaultLayout,
    component: Areas,
    exact: true
  },
  {
    path: "/areas/:area_id",
    layout: DefaultLayout,
    component: AreaDetailsView,
    exact: false
  },
  {
    path: "/apps",
    layout: DefaultLayout,
    component: Apps,
    exact: true
  },
  {
    path: "/apps/:app_name",
    layout: DefaultLayout,
    component: AppDetailsView,
    exact: false
  }
];
